/* Niqab Boutique — global.js */
(function () {
  'use strict';
  var CFG = window.NIQAB || { strings: {} };
  var S = CFG.strings || {};

  function money(cents) {
    var v = (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var fmt = CFG.moneyFormat;
    if (fmt && typeof fmt === 'string') {
      return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/g, v).replace(/<[^>]+>/g, '');
    }
    return 'LE ' + v;
  }
  function store(key, val) {
    try {
      if (arguments.length === 2) { localStorage.setItem(key, JSON.stringify(val)); return val; }
      return JSON.parse(localStorage.getItem(key) || 'null');
    } catch (e) { return arguments.length === 2 ? val : null; }
  }

  /* ---------- Drawers ---------- */
  function openDrawer(sel) {
    var d = document.querySelector(sel);
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var f = d.querySelector('input, button, a');
    if (f) setTimeout(function () { f.focus(); }, 80);
  }
  function closeDrawers() {
    document.querySelectorAll('.drawer.is-open').forEach(function (d) {
      d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    });
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); closeDrawers(); openDrawer(opener.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('drawer__overlay')) closeDrawers();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Announcement rotate + dismiss ---------- */
  document.querySelectorAll('[data-announcement]').forEach(function (bar) {
    try { if (sessionStorage.getItem('niqab_ann_dismissed')) { bar.classList.add('is-dismissed'); return; } } catch (e) {}
    var items = [].slice.call(bar.querySelectorAll('[data-ann-item]'));
    var i = 0;
    if (items.length > 1) {
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, parseInt(bar.getAttribute('data-interval') || '4000', 10));
    }
    var close = bar.querySelector('[data-ann-close]');
    close && close.addEventListener('click', function () {
      bar.classList.add('is-dismissed');
      try { sessionStorage.setItem('niqab_ann_dismissed', '1'); } catch (e) {}
    });
  });

  /* ---------- Qty steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn || btn.hasAttribute('data-cart-qty')) return;
    var wrap = btn.closest('[data-qty]');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var val = (parseInt(input.value, 10) || 1) + (btn.hasAttribute('data-qty-plus') ? 1 : -1);
    input.value = Math.max(1, val);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product gallery (scroll-snap slider: swipe / thumbs / dots / arrows / variant sync) ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gal) {
    var track = gal.querySelector('[data-gallery-track]');
    var slides = [].slice.call(gal.querySelectorAll('[data-gallery-slide]'));
    if (!track || !slides.length) return;
    var thumbs = [].slice.call(gal.querySelectorAll('[data-gallery-thumb]'));
    var dots = [].slice.call(gal.querySelectorAll('[data-gallery-dot]'));
    var current = 0;

    function mark(i) {
      current = i;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    /* Rect-based scrolling: identical behavior in LTR and RTL, no scrollLeft sign math. */
    function goTo(i, instant) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      var delta = slides[i].getBoundingClientRect().left - track.getBoundingClientRect().left;
      track.scrollBy({ left: delta, behavior: instant ? 'auto' : 'smooth' });
      mark(i);
    }
    function nearest() {
      var origin = track.getBoundingClientRect().left;
      var best = 0, bd = Infinity;
      slides.forEach(function (s, k) {
        var d = Math.abs(s.getBoundingClientRect().left - origin);
        if (d < bd) { bd = d; best = k; }
      });
      return best;
    }
    var st = null;
    track.addEventListener('scroll', function () {
      clearTimeout(st);
      st = setTimeout(function () { mark(nearest()); }, 90);
    }, { passive: true });

    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { goTo(k); }); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { goTo(k); }); });
    gal.querySelectorAll('[data-gallery-prev]').forEach(function (b) { b.addEventListener('click', function () { goTo(current - 1); }); });
    gal.querySelectorAll('[data-gallery-next]').forEach(function (b) { b.addEventListener('click', function () { goTo(current + 1); }); });

    /* Called on variant change when the variant has a featured media. */
    gal.goToMedia = function (mediaId) {
      if (mediaId == null) return;
      for (var k = 0; k < slides.length; k++) {
        if (slides[k].getAttribute('data-media-id') === String(mediaId)) { goTo(k); return; }
      }
    };
  });

  /* ---------- Variant selection ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var variants = [];
    try {
      var vEl = form.querySelector('[data-variants]');
      variants = JSON.parse((vEl ? vEl.textContent : '[]') || '[]');
    } catch (err) { variants = []; }
    var idInput = form.querySelector('[name="id"]');
    var priceEls = document.querySelectorAll('[data-product-price]');
    var atcs = document.querySelectorAll('[data-atc]');
    function selectedOptions() {
      var opts = [];
      form.querySelectorAll('[data-option-index]').forEach(function (group) {
        var active = group.querySelector('[data-value].is-active');
        opts[parseInt(group.getAttribute('data-option-index'), 10)] = active ? active.getAttribute('data-value') : null;
      });
      return opts;
    }
    function update() {
      var opts = selectedOptions();
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
      if (!v) return;
      if (idInput) idInput.value = v.id;
      priceEls.forEach(function (el) {
        var html = '<span class="price__regular">' + money(v.price) + '</span>';
        if (v.compare_at_price && v.compare_at_price > v.price) {
          html = '<span class="price__sale">' + money(v.price) + '</span> <s class="price__compare">' + money(v.compare_at_price) + '</s>';
        }
        el.innerHTML = html;
      });
      atcs.forEach(function (atc) {
        var span = atc.querySelector('span');
        if (v.available) { atc.removeAttribute('disabled'); span && (span.textContent = atc.getAttribute('data-add-label')); }
        else { atc.setAttribute('disabled', ''); span && (span.textContent = atc.getAttribute('data-sold-label')); }
      });
      if (v.media_id != null) {
        var gal = document.querySelector('[data-gallery]');
        if (gal && gal.goToMedia) gal.goToMedia(v.media_id);
      }
    }
    form.querySelectorAll('[data-option-index] [data-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-unavailable')) return;
        var group = btn.closest('[data-option-index]');
        group.querySelectorAll('[data-value]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var lbl = group.querySelector('[data-option-selected]');
        if (lbl) lbl.textContent = btn.getAttribute('data-value');
        update();
      });
    });
  });

  /* ---------- Cart ---------- */
  function refreshCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count; el.hidden = cart.item_count === 0;
      });
    });
  }
  function renderFreeShip(total) {
    var box = document.querySelector('[data-freeship]');
    if (!box) return;
    var goal = CFG.freeShippingThreshold || 0;
    if (!goal || !CFG.showFreeShipping) { box.hidden = true; return; }
    box.hidden = false;
    var text = box.querySelector('[data-freeship-text]');
    var fill = box.querySelector('[data-freeship-fill]');
    var knob = box.querySelector('[data-freeship-knob]');
    var pct = Math.min(100, Math.round((total / goal) * 100));
    if (fill) fill.style.width = pct + '%';
    if (knob) knob.style.setProperty('--p', pct + '%');
    if (text) {
      if (total >= goal) { text.textContent = S.freeShipDone || 'Free shipping unlocked!'; text.classList.add('is-done'); }
      else {
        var left = money(goal - total);
        text.textContent = (S.freeShipLeft || 'Spend [amount] more for free shipping').replace('[amount]', left);
        text.classList.remove('is-done');
      }
    }
  }
  function renderCartDrawer(showToast) {
    var body = document.querySelector('[data-cart-body]');
    var foot = document.querySelector('[data-cart-foot]');
    if (!body) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      renderFreeShip(cart.total_price);
      var toast = document.querySelector('[data-cart-toast]');
      if (toast) {
        toast.hidden = !showToast;
        if (showToast) setTimeout(function () { toast.hidden = true; }, 3500);
      }
      if (cart.item_count === 0) {
        body.innerHTML = '<div class="cart-empty"><p>' + (body.getAttribute('data-empty') || 'Your cart is empty.') + '</p><a class="btn" href="/collections/all">' + (body.getAttribute('data-shop') || 'Shop now') + '</a></div>';
        if (foot) foot.hidden = true;
        return;
      }
      if (foot) foot.hidden = false;
      var html = '';
      cart.items.forEach(function (it) {
        html += '<div class="cart-line" data-key="' + it.key + '">' +
          '<a class="cart-line__media" href="' + it.url + '">' + (it.image ? '<img src="' + it.image + '&width=160" alt="" loading="lazy" onerror="this.src=\'' + it.image + '\'">' : '') + '</a>' +
          '<div class="cart-line__details"><a class="cart-line__title" href="' + it.url + '">' + it.product_title + '</a>' +
          (it.variant_title ? '<span class="cart-line__variant">' + it.variant_title + '</span>' : '') +
          '<span class="cart-line__price">' + money(it.final_line_price) + '</span>' +
          '<div class="cart-line__controls"><div class="qty" data-qty>' +
          '<button type="button" data-qty-plus data-cart-qty="' + it.key + '" data-dir="1" aria-label="+">+</button>' +
          '<input type="text" value="' + it.quantity + '" readonly>' +
          '<button type="button" data-qty-minus data-cart-qty="' + it.key + '" data-dir="-1" aria-label="-">&minus;</button>' +
          '</div><button type="button" class="cart-line__remove" data-cart-remove="' + it.key + '">' + (body.getAttribute('data-remove') || 'Remove') + '</button></div>' +
          '</div></div>';
      });
      body.innerHTML = html;
      var totalEl = document.querySelector('[data-cart-total]');
      if (totalEl) totalEl.textContent = money(cart.total_price);
      var noteArea = document.querySelector('[data-cart-note-input]');
      if (noteArea && !noteArea.matches(':focus')) noteArea.value = cart.note || '';
    });
  }
  function addToCart(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      refreshCount();
      if (CFG.cartType === 'page') { window.location.href = '/cart'; return; }
      renderCartDrawer(true); openDrawer('#CartDrawer');
    }).catch(function () {});
  }
  function changeCart(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function () { refreshCount(); renderCartDrawer(false); });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var id = form.querySelector('[name="id"]').value;
    var q = form.querySelector('[name="quantity"]');
    addToCart(id, q ? parseInt(q.value, 10) : 1);
  });
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-quick-add]');
    if (qa) { e.preventDefault(); addToCart(qa.getAttribute('data-quick-add'), 1); return; }
    var rm = e.target.closest('[data-cart-remove]');
    if (rm) { changeCart(rm.getAttribute('data-cart-remove'), 0); return; }
    var cq = e.target.closest('[data-cart-qty]');
    if (cq) {
      var line = cq.closest('.cart-line');
      var input = line.querySelector('input');
      var val = Math.max(0, (parseInt(input.value, 10) || 1) + parseInt(cq.getAttribute('data-dir'), 10));
      changeCart(cq.getAttribute('data-cart-qty'), val);
    }
  });
  document.querySelectorAll('[data-drawer-open="#CartDrawer"]').forEach(function (b) {
    b.addEventListener('click', function () { renderCartDrawer(false); });
  });
  if (document.querySelector('[data-cart-body]')) renderCartDrawer(false);

  /* cart note + coupon tools */
  document.querySelectorAll('[data-cart-tool-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var tool = document.querySelector(btn.getAttribute('data-cart-tool-toggle'));
      if (!tool) return;
      var show = tool.hidden;
      document.querySelectorAll('.cart-tool').forEach(function (t) { t.hidden = true; });
      document.querySelectorAll('[data-cart-tool-toggle]').forEach(function (b) { b.classList.remove('is-active'); });
      tool.hidden = !show;
      btn.classList.toggle('is-active', show);
    });
  });
  var noteSave = document.querySelector('[data-cart-note-save]');
  noteSave && noteSave.addEventListener('click', function () {
    var v = (document.querySelector('[data-cart-note-input]') || {}).value || '';
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: v }) })
      .then(function () { noteSave.textContent = noteSave.getAttribute('data-saved') || '✓'; setTimeout(function(){ noteSave.textContent = noteSave.getAttribute('data-label'); }, 1600); });
  });
  var couponApply = document.querySelector('[data-coupon-apply]');
  couponApply && couponApply.addEventListener('click', function () {
    var code = ((document.querySelector('[data-coupon-input]') || {}).value || '').trim();
    if (code) window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=%2Fcheckout';
  });

  /* ---------- Wishlist ---------- */
  var WKEY = 'niqab_wishlist';
  function wishList() { return store(WKEY) || []; }
  function wishHas(handle) { return wishList().some(function (i) { return i.handle === handle; }); }
  function wishRender() {
    var list = wishList();
    document.querySelectorAll('[data-wish-count]').forEach(function (el) { el.textContent = list.length; el.hidden = list.length === 0; });
    document.querySelectorAll('[data-wish-toggle]').forEach(function (b) {
      b.classList.toggle('is-active', wishHas(b.getAttribute('data-handle')));
    });
    var body = document.querySelector('[data-wish-body]');
    if (body) {
      if (!list.length) body.innerHTML = '<p class="text-muted text-center mt-2">' + (S.wishlistEmpty || 'Your wishlist is empty.') + '</p>';
      else body.innerHTML = list.map(function (i) {
        return '<div class="wish-item"><a href="' + i.url + '">' + (i.img ? '<img src="' + i.img + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div><a class="wish-item__title" href="' + i.url + '">' + i.title + '</a><div class="wish-item__price">' + i.price + '</div></div>' +
          '<button type="button" class="wish-item__remove" data-wish-remove="' + i.handle + '" aria-label="Remove"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>';
      }).join('');
    }
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-wish-toggle]');
    if (t) {
      e.preventDefault();
      var handle = t.getAttribute('data-handle');
      var list = wishList();
      if (wishHas(handle)) list = list.filter(function (i) { return i.handle !== handle; });
      else list.push({ handle: handle, title: t.getAttribute('data-title'), url: t.getAttribute('data-url'), img: t.getAttribute('data-img'), price: t.getAttribute('data-price') });
      store(WKEY, list); wishRender(); return;
    }
    var r = e.target.closest('[data-wish-remove]');
    if (r) { store(WKEY, wishList().filter(function (i) { return i.handle !== r.getAttribute('data-wish-remove'); })); wishRender(); }
  });
  wishRender();

  /* ---------- Compare ---------- */
  var CKEY = 'niqab_compare';
  function compList() { return store(CKEY) || []; }
  function compRender() {
    var list = compList();
    var body = document.querySelector('[data-compare-body]');
    if (!body) return;
    if (!list.length) body.innerHTML = '<p class="text-muted text-center mt-2">' + (S.compareEmpty || 'Nothing to compare yet.') + '</p>';
    else body.innerHTML = '<div class="compare-grid">' + list.map(function (i) {
      return '<div class="compare-col"><button type="button" class="wish-item__remove" data-compare-remove="' + i.handle + '" aria-label="Remove"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
        (i.img ? '<img src="' + i.img + '" alt="">' : '') +
        '<span class="compare-col__title">' + i.title + '</span><span class="compare-col__price">' + i.price + '</span>' +
        '<a class="btn btn--sm" href="' + i.url + '">→</a></div>';
    }).join('') + '</div>';
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-compare-toggle]');
    if (t) {
      e.preventDefault();
      var handle = t.getAttribute('data-handle');
      var list = compList().filter(function (i) { return i.handle !== handle; });
      list.unshift({ handle: handle, title: t.getAttribute('data-title'), url: t.getAttribute('data-url'), img: t.getAttribute('data-img'), price: t.getAttribute('data-price') });
      store(CKEY, list.slice(0, 4)); compRender(); openDrawer('#CompareDrawer'); return;
    }
    var r = e.target.closest('[data-compare-remove]');
    if (r) { store(CKEY, compList().filter(function (i) { return i.handle !== r.getAttribute('data-compare-remove'); })); compRender(); }
  });
  compRender();

  /* ---------- Recently viewed ---------- */
  var RKEY = 'niqab_recent';
  var saveEl = document.querySelector('[data-recent-save]');
  if (saveEl) {
    try {
      var p = JSON.parse(saveEl.textContent);
      var list = (store(RKEY) || []).filter(function (i) { return i.handle !== p.handle; });
      list.unshift(p);
      store(RKEY, list.slice(0, 12));
    } catch (e) {}
  }
  document.querySelectorAll('[data-recent-rail]').forEach(function (rail) {
    var exclude = rail.getAttribute('data-exclude');
    var list = (store(RKEY) || []).filter(function (i) { return i.handle !== exclude; });
    var section = rail.closest('[data-recent-section]');
    if (!list.length) { if (section) section.hidden = true; return; }
    if (section) section.hidden = false;
    rail.innerHTML = list.map(function (i) {
      return '<div class="card"><a class="card__media ratio-portrait" href="' + i.url + '">' + (i.img ? '<img class="img-1" src="' + i.img + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="card__body"><h3 class="card__title"><a href="' + i.url + '">' + i.title + '</a></h3><div class="price"><span class="price__regular">' + i.price + '</span></div></div></div>';
    }).join('');
  });

  /* ---------- Social proof ---------- */
  document.querySelectorAll('[data-viewers]').forEach(function (el) {
    var min = parseInt(el.getAttribute('data-min') || '10', 10);
    var max = parseInt(el.getAttribute('data-max') || '40', 10);
    var target = el.querySelector('strong') || el;
    function set() { target.textContent = Math.floor(min + Math.random() * (max - min + 1)); }
    set(); setInterval(set, 24000 + Math.random() * 12000);
  });

  /* ---------- Tabs ---------- */
  document.querySelectorAll('[data-tabs]').forEach(function (root) {
    var btns = [].slice.call(root.querySelectorAll('[data-tab-btn]'));
    var panels = [].slice.call(root.querySelectorAll('[data-tab-panel]'));
    btns.forEach(function (b, k) {
      b.addEventListener('click', function () {
        btns.forEach(function (x, i) { x.classList.toggle('is-active', i === k); x.setAttribute('aria-selected', i === k); });
        panels.forEach(function (p, i) { p.hidden = i !== k; });
      });
    });
  });

  /* ---------- Sticky ATC ---------- */
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var anchor = document.querySelector('[data-atc-anchor]');
  if (stickyBar && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(anchor);
    var sBtn = stickyBar.querySelector('[data-sticky-submit]');
    sBtn && sBtn.addEventListener('click', function () {
      var form = document.querySelector('[data-product-form]');
      if (form) form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
  }

  /* ---------- Share ---------- */
  document.querySelectorAll('[data-share]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var url = btn.getAttribute('data-url') || location.href;
      var title = btn.getAttribute('data-title') || document.title;
      if (navigator.share) { navigator.share({ title: title, url: url }).catch(function () {}); return; }
      (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject()).then(function () {
        var span = btn.querySelector('span');
        if (span) { var old = span.textContent; span.textContent = S.copied || 'Copied!'; setTimeout(function () { span.textContent = old; }, 1600); }
      }).catch(function () {});
    });
  });

  /* ---------- Carousel rails ---------- */
  document.querySelectorAll('.rail-wrap').forEach(function (wrap) {
    var rail = wrap.querySelector('.product-rail, .carousel__track');
    var bar = wrap.querySelector('.rail-progress__bar');
    if (!rail) return;
    function upd() {
      if (!bar) return;
      var max = rail.scrollWidth - rail.clientWidth;
      bar.style.width = (max > 0 ? Math.max(12, (Math.abs(rail.scrollLeft) / max) * 100) : 100) + '%';
    }
    rail.addEventListener('scroll', upd, { passive: true }); upd();
    wrap.querySelectorAll('[data-rail-prev]').forEach(function (b) { b.addEventListener('click', function () { rail.scrollBy({ left: -rail.clientWidth * 0.85, behavior: 'smooth' }); }); });
    wrap.querySelectorAll('[data-rail-next]').forEach(function (b) { b.addEventListener('click', function () { rail.scrollBy({ left: rail.clientWidth * 0.85, behavior: 'smooth' }); }); });
  });

  /* ---------- Predictive search ---------- */
  document.querySelectorAll('[data-predictive-search]').forEach(function (psForm) {
    var input = psForm.querySelector('[data-predictive-input]');
    var results = psForm.parentElement.querySelector('[data-predictive-results]') || psForm.querySelector('[data-predictive-results]');
    if (!input || !results) return;
    var t = null;
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(t);
      if (q.length < 2) { results.innerHTML = ''; return; }
      t = setTimeout(function () {
        fetch('/search/suggest?q=' + encodeURIComponent(q) + '&section_id=predictive-search&resources[type]=product,collection,article,page&resources[limit]=6')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('[data-predictive]');
            results.innerHTML = inner ? inner.innerHTML : '';
          }).catch(function () {});
      }, 220);
    });
  });

  /* ---------- Facets sort ---------- */
  document.querySelectorAll('[data-facets-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () { var f = sel.closest('form'); if (f) f.submit(); });
  });

  /* ---------- Address delete ---------- */
  document.querySelectorAll('[data-address-delete]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!confirm(btn.getAttribute('data-confirm') || 'Delete this address?')) return;
      var f = document.createElement('form');
      f.method = 'post'; f.action = btn.getAttribute('data-address-delete');
      f.innerHTML = '<input type="hidden" name="_method" value="delete">';
      document.body.appendChild(f); f.submit();
    });
  });

  /* ---------- Hero slideshow ---------- */
  document.querySelectorAll('[data-slideshow]').forEach(function (root) {
    var slides = [].slice.call(root.querySelectorAll('[data-slide]'));
    var dots = [].slice.call(root.querySelectorAll('[data-slide-dot]'));
    if (slides.length < 2) return;
    var i = 0, timer = null;
    var interval = parseInt(root.getAttribute('data-interval') || '5000', 10);
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function start() { stop(); if (interval > 0) timer = setInterval(function () { show(i + 1); }, interval); }
    function stop() { if (timer) clearInterval(timer); }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); start(); }); });
    root.querySelectorAll('[data-slide-prev]').forEach(function (b) { b.addEventListener('click', function () { show(i - 1); start(); }); });
    root.querySelectorAll('[data-slide-next]').forEach(function (b) { b.addEventListener('click', function () { show(i + 1); start(); }); });
    show(0); start();
  });

  refreshCount();
})();
document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.header');

  if (!header) return;

  function handleHeader() {
    if (window.scrollY > 80) {
      header.classList.add('is-visible');
    } else {
      header.classList.remove('is-visible');
    }
  }

  window.addEventListener('scroll', handleHeader, { passive: true });

  handleHeader();
});
